(function () {
  "use strict";

  var FIELDS = [
    "analytics_storage",
    "ad_storage",
    "ad_user_data",
    "ad_personalization",
  ];
  var CACHE_KEY = "doggoCookieConsent";
  var METAFIELD_KEY = "doggo_gcm";
  var root = document.querySelector("[data-cookie-consent]");
  var consent = window.DoggoConsent || {};

  if (!root || consent.initialized) return;
  consent.initialized = true;
  consent.ready = false;

  var version = parseInt(root.getAttribute("data-cookie-consent-version"), 10) || 1;
  var validityDays = parseInt(root.getAttribute("data-cookie-consent-validity-days"), 10) || 365;
  var uiEnabled = root.getAttribute("data-cookie-consent-ui-enabled") === "true";
  var configuredCookieDomain = root.getAttribute("data-cookie-consent-cookie-domain") || "";
  var banner = root.querySelector("[data-cookie-consent-banner]");
  var overlay = root.querySelector("[data-cookie-consent-overlay]");
  var modal = root.querySelector("[data-cookie-consent-modal]");
  var bannerError = root.querySelector("[data-cookie-consent-error]");
  var modalError = root.querySelector("[data-cookie-consent-modal-error]");
  var fieldInputs = root.querySelectorAll("[data-cookie-consent-field]");
  var actionButtons = root.querySelectorAll(
    "[data-cookie-consent-accept], [data-cookie-consent-reject], [data-cookie-consent-save]",
  );
  var privacyApi = null;
  var isSaving = false;
  var lastFocusedElement = null;
  var appliedEffectiveState = null;

  function deniedState() {
    return {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    };
  }

  function normalizeState(input) {
    var normalized = deniedState();
    FIELDS.forEach(function (field) {
      normalized[field] = input && input[field] === "granted" ? "granted" : "denied";
    });
    return normalized;
  }

  function parseMetafield(value, now) {
    if (typeof value !== "string") return null;
    var parts = value.split("|");
    if (parts.length !== 3 || Number(parts[0]) !== version || !/^\d{4}$/.test(parts[2])) return null;

    var updatedAt = Number(parts[1]);
    var maxAge = validityDays * 24 * 60 * 60;
    if (!Number.isFinite(updatedAt) || updatedAt <= 0 || now - updatedAt > maxAge || updatedAt > now + 300) {
      return null;
    }

    var parsed = deniedState();
    FIELDS.forEach(function (field, index) {
      parsed[field] = parts[2].charAt(index) === "1" ? "granted" : "denied";
    });
    return parsed;
  }

  function serializeMetafield(state, now) {
    var bits = FIELDS.map(function (field) {
      return state[field] === "granted" ? "1" : "0";
    }).join("");
    return version + "|" + now + "|" + bits;
  }

  function readMetafield() {
    if (!privacyApi || typeof privacyApi.getTrackingConsentMetafield !== "function") return null;
    try {
      return parseMetafield(privacyApi.getTrackingConsentMetafield(METAFIELD_KEY), Math.floor(Date.now() / 1000));
    } catch (error) {
      return null;
    }
  }

  function readCache() {
    try {
      var cached = JSON.parse(window.localStorage.getItem(CACHE_KEY));
      if (!cached || cached.version !== version || typeof cached.updatedAt !== "string") return null;
      var updatedAt = Date.parse(cached.updatedAt);
      if (!Number.isFinite(updatedAt) || Date.now() - updatedAt > validityDays * 86400000 || updatedAt > Date.now() + 300000) {
        return null;
      }
      return normalizeState(cached);
    } catch (error) {
      try {
        window.localStorage.removeItem(CACHE_KEY);
      } catch (storageError) {}
      return null;
    }
  }

  function writeCache(state) {
    try {
      window.localStorage.setItem(
        CACHE_KEY,
        JSON.stringify(
          Object.assign(
            {
              version: version,
              updatedAt: new Date().toISOString(),
            },
            state,
          ),
        ),
      );
    } catch (error) {}
  }

  function hasMarketingSelection(state) {
    return (
      state.ad_storage === "granted" ||
      state.ad_user_data === "granted" ||
      state.ad_personalization === "granted"
    );
  }

  function selectedMarketingAllowed(state) {
    return (
      state.ad_storage === "granted" &&
      state.ad_user_data === "granted" &&
      state.ad_personalization === "granted"
    );
  }

  function privacyAllows(method, fallback) {
    if (!privacyApi || typeof privacyApi[method] !== "function") return fallback === true;
    try {
      return privacyApi[method]() === true;
    } catch (error) {
      return false;
    }
  }

  function effectiveState(input) {
    var effective = normalizeState(input);
    if (!consent.ready || !privacyAllows("analyticsProcessingAllowed", false)) {
      effective.analytics_storage = "denied";
    }
    if (!consent.ready || !privacyAllows("marketingAllowed", false)) {
      effective.ad_storage = "denied";
      effective.ad_user_data = "denied";
      effective.ad_personalization = "denied";
    } else if (!privacyAllows("saleOfDataAllowed", true)) {
      effective.ad_user_data = "denied";
      effective.ad_personalization = "denied";
    }
    return effective;
  }

  function analyticsProcessingAllowed() {
    return effectiveState(consent.state).analytics_storage === "granted";
  }

  function marketingProcessingAllowed() {
    return selectedMarketingAllowed(effectiveState(consent.state));
  }

  function emitUpdate(currentEffectiveState) {
    var effective = currentEffectiveState || effectiveState(consent.state);
    document.dispatchEvent(
      new CustomEvent("doggo:consent-updated", {
        detail: Object.assign(
          {
            ready: consent.ready,
            analyticsAllowed: effective.analytics_storage === "granted",
            marketingAllowed: selectedMarketingAllowed(effective),
          },
          effective,
        ),
      }),
    );
  }

  function updateGoogleConsent(currentEffectiveState) {
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", currentEffectiveState || effectiveState(consent.state));
    }
  }

  function applyState(nextState, ready) {
    consent.state = normalizeState(nextState);
    consent.ready = ready === true;
    var nextEffective = effectiveState(consent.state);
    updateInputs(consent.state);
    updateGoogleConsent(nextEffective);
    emitUpdate(nextEffective);
    appliedEffectiveState = nextEffective;
  }

  consent.getState = function () {
    return normalizeState(consent.state);
  };
  consent.getEffectiveState = function () {
    return effectiveState(consent.state);
  };
  consent.isAllowed = function (field) {
    if (!consent.ready || FIELDS.indexOf(field) === -1) return false;
    return effectiveState(consent.state)[field] === "granted";
  };
  consent.isAnalyticsAllowed = function () {
    return consent.ready && analyticsProcessingAllowed();
  };
  consent.isMarketingAllowed = function () {
    return consent.ready && marketingProcessingAllowed();
  };
  consent._test = {
    cookieDomains: cookieDomains,
    effectiveState: effectiveState,
    hasMarketingSelection: hasMarketingSelection,
    normalizeState: normalizeState,
    parseMetafield: parseMetafield,
    serializeMetafield: serializeMetafield,
    selectedMarketingAllowed: selectedMarketingAllowed,
  };
  window.DoggoConsent = consent;

  function setError(visible) {
    if (bannerError) bannerError.hidden = !visible;
    if (modalError) modalError.hidden = !visible;
  }

  function setSaving(saving) {
    isSaving = saving;
    for (var index = 0; index < actionButtons.length; index += 1) {
      actionButtons[index].disabled = saving;
      actionButtons[index].setAttribute("aria-busy", String(saving));
    }
  }

  function updateInputs(state) {
    for (var index = 0; index < fieldInputs.length; index += 1) {
      var field = fieldInputs[index].getAttribute("data-cookie-consent-field");
      fieldInputs[index].checked = state[field] === "granted";
    }
  }

  function inputState() {
    var nextState = deniedState();
    for (var index = 0; index < fieldInputs.length; index += 1) {
      var field = fieldInputs[index].getAttribute("data-cookie-consent-field");
      nextState[field] = fieldInputs[index].checked ? "granted" : "denied";
    }
    return nextState;
  }

  function showBanner(show) {
    if (banner) banner.hidden = !show;
  }

  function closePreferences() {
    if (!overlay || isSaving) return;
    overlay.hidden = true;
    document.body.classList.remove("cookie-consent-modal-open");
    if (lastFocusedElement && document.contains(lastFocusedElement)) lastFocusedElement.focus();
    lastFocusedElement = null;
  }

  function openPreferences(trigger) {
    if (!uiEnabled || !overlay || !modal) return;
    setError(!privacyApi);
    updateInputs(consent.ready ? consent.state : readCache() || deniedState());
    lastFocusedElement = trigger || document.activeElement;
    overlay.hidden = false;
    document.body.classList.add("cookie-consent-modal-open");
    modal.focus();
  }
  consent.openPreferences = openPreferences;

  function focusableElements() {
    return modal.querySelectorAll(
      'button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])',
    );
  }

  function handleModalKeydown(event) {
    if (event.key === "Escape") {
      event.preventDefault();
      closePreferences();
      return;
    }
    if (event.key !== "Tab") return;

    var focusable = focusableElements();
    if (!focusable.length) {
      event.preventDefault();
      modal.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === modal)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function cookieDomains(hostname, configuredDomain) {
    var host = String(hostname || "").toLowerCase().replace(/^\.+|\.+$/g, "");
    var configured = String(configuredDomain || "").toLowerCase().replace(/^\.+|\.+$/g, "");
    var domains = [];

    function add(domain) {
      if (domain && domains.indexOf(domain) === -1) domains.push(domain);
    }

    add(host);
    add(host && "." + host);

    if (
      configured &&
      /^[a-z0-9.-]+$/.test(configured) &&
      (host === configured || host.slice(-(configured.length + 1)) === "." + configured)
    ) {
      add(configured);
      add("." + configured);
    }

    return domains;
  }

  function clearTrackingCookies() {
    var cookieNames = document.cookie
      .split(";")
      .map(function (cookie) { return cookie.split("=")[0].trim(); })
      .filter(function (name) {
        return /^(?:_ga|_gid|_gat|_gcl_|_fbp$|_fbc$|_clck$|_clsk$)/.test(name);
      });
    var domains = cookieDomains(window.location.hostname, configuredCookieDomain);
    cookieNames.forEach(function (name) {
      document.cookie = name + "=; Max-Age=0; path=/; SameSite=Lax";
      domains.forEach(function (domain) {
        document.cookie = name + "=; Max-Age=0; path=/; domain=" + domain + "; SameSite=Lax";
      });
    });
  }

  function losesPermission(previous, nextState) {
    return FIELDS.some(function (field) {
      return previous[field] === "granted" && nextState[field] === "denied";
    });
  }

  function saveConsent(nextState, options) {
    if (isSaving) return;

    if (!privacyApi) {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== "function") {
        setError(true);
        return;
      }

      setSaving(true);
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function (error) {
          setSaving(false);
          privacyApi = !error && window.Shopify.customerPrivacy;
          if (!privacyApi) {
            setError(true);
            return;
          }
          saveConsent(nextState, options);
        },
      );
      return;
    }

    if (typeof privacyApi.setTrackingConsent !== "function") {
      setError(true);
      return;
    }

    var normalized = normalizeState(nextState);
    var previous = normalizeState(consent.state);
    var shouldClearCookies = (options && options.clearCookies === true) || losesPermission(previous, normalized);
    setError(false);
    setSaving(true);

    if (shouldClearCookies) {
      applyState(normalized, true);
      clearTrackingCookies();
    }

    try {
      privacyApi.setTrackingConsent(
        {
          analytics: normalized.analytics_storage === "granted",
          marketing: hasMarketingSelection(normalized),
          metafields: [
            {
              key: METAFIELD_KEY,
              value: serializeMetafield(normalized, Math.floor(Date.now() / 1000)),
            },
          ],
        },
        function (result) {
          setSaving(false);
          if (result && result.error) {
            applyState(deniedState(), false);
            setError(true);
            showBanner(uiEnabled);
            return;
          }

          applyState(normalized, true);
          writeCache(normalized);
          showBanner(false);
          closePreferences();

          if (shouldClearCookies) {
            window.setTimeout(function () { window.location.reload(); }, 50);
          }
        },
      );
    } catch (error) {
      setSaving(false);
      applyState(deniedState(), false);
      setError(true);
      showBanner(uiEnabled);
    }
  }

  root.addEventListener("click", function (event) {
    var button = event.target.closest("button");
    if (!button) return;
    if (button.hasAttribute("data-cookie-consent-manage")) openPreferences(button);
    if (button.hasAttribute("data-cookie-consent-close")) closePreferences();
    if (button.hasAttribute("data-cookie-consent-accept")) {
      saveConsent({
        analytics_storage: "granted",
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
      });
    }
    if (button.hasAttribute("data-cookie-consent-reject")) saveConsent(deniedState(), { clearCookies: true });
    if (button.hasAttribute("data-cookie-consent-save")) saveConsent(inputState());
  });

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest('[data-cookie-preferences-open], a[href="#cookie-preferences"]');
    if (!trigger) return;
    event.preventDefault();
    openPreferences(trigger);
  });

  if (modal) modal.addEventListener("keydown", handleModalKeydown);
  if (overlay) {
    overlay.addEventListener("mousedown", function (event) {
      if (event.target === overlay) closePreferences();
    });
  }

  function handleApiError() {
    privacyApi = null;
    applyState(deniedState(), false);
    setError(true);
    showBanner(uiEnabled);
  }

  function initializeFromPrivacyApi() {
    privacyApi = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacyApi) {
      handleApiError();
      return;
    }

    var storedState = readMetafield();
    var visitorConsent = readVisitorConsent();
    if (!storedState) {
      var migratedState = stateFromVisitorConsent(visitorConsent);
      if (migratedState) {
        applyState(migratedState, true);
        writeCache(migratedState);
        setError(false);
        showBanner(false);
        return;
      }
      applyState(deniedState(), true);
      showBanner(uiEnabled);
      return;
    }

    if (visitorConsent) {
      if (visitorConsent.analytics === "no") storedState.analytics_storage = "denied";
      if (visitorConsent.marketing === "no") {
        storedState.ad_storage = "denied";
        storedState.ad_user_data = "denied";
        storedState.ad_personalization = "denied";
      }
    }

    applyState(storedState, true);
    writeCache(storedState);
    setError(false);
    showBanner(false);
  }

  function readVisitorConsent() {
    if (!privacyApi || typeof privacyApi.currentVisitorConsent !== "function") return null;
    try {
      var current = privacyApi.currentVisitorConsent();
      return current && typeof current === "object" ? current : null;
    } catch (error) {
      return null;
    }
  }

  function stateFromVisitorConsent(current) {
    current = current || readVisitorConsent();
    try {
      if (
        !current ||
        !/^(?:yes|no)$/.test(current.analytics) ||
        !/^(?:yes|no)$/.test(current.marketing)
      ) return null;
      return {
        analytics_storage: current.analytics === "yes" ? "granted" : "denied",
        ad_storage: current.marketing === "yes" ? "granted" : "denied",
        ad_user_data: current.marketing === "yes" ? "granted" : "denied",
        ad_personalization: current.marketing === "yes" ? "granted" : "denied",
      };
    } catch (error) {
      return null;
    }
  }

  function synchronizeExternalConsent() {
    var externalState = stateFromVisitorConsent();
    if (!externalState) {
      initializeFromPrivacyApi();
      return;
    }
    var previousEffective = appliedEffectiveState || deniedState();
    applyState(externalState, true);
    writeCache(externalState);
    showBanner(false);
    setError(false);
    if (losesPermission(previousEffective, effectiveState(externalState))) clearTrackingCookies();
  }

  document.addEventListener("visitorConsentCollected", function () {
    if (!isSaving) synchronizeExternalConsent();
  });

  window.addEventListener("storage", function (event) {
    if (event.key === CACHE_KEY && !isSaving) initializeFromPrivacyApi();
  });

  updateInputs(readCache() || deniedState());
  if (!window.Shopify || typeof window.Shopify.loadFeatures !== "function") {
    handleApiError();
    return;
  }

  window.Shopify.loadFeatures(
    [{ name: "consent-tracking-api", version: "0.1" }],
    function (error) {
      if (error) {
        handleApiError();
        return;
      }
      initializeFromPrivacyApi();
    },
  );
})();
